import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ShopsIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ShopsIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.78141 16.8172C6.90762 16.7725 6.92408 15.5435 7.78137 15.5008C10.2098 15.5093 16.615 15.5031 19.1207 15.5049C19.806 15.5049 20.3924 15.0385 20.5465 14.3708L21.9693 8.20964C22.0508 7.85687 21.9685 7.49176 21.7437 7.20797C21.5189 6.92418 21.1824 6.75914 20.8204 6.75914C19.8124 6.75914 11.256 6.72041 6.8735 6.70294L6.17879 4.12528C6.01202 3.50929 5.44989 3.0791 4.81173 3.0791H2.58625C2.26248 3.0791 2 3.34158 2 3.66535C2 3.98912 2.26248 4.2516 2.58625 4.2516H4.81173C4.92159 4.2516 5.01832 4.32566 5.04689 4.43107L7.71492 14.33C7.2458 14.347 6.80885 14.5378 6.4775 14.874C6.12935 15.2273 5.94237 15.695 5.95101 16.1909C5.96828 17.1827 6.78939 17.9896 7.7814 17.9896H8.63623C8.50917 18.2563 8.43784 18.5545 8.43784 18.869C8.43784 20.0005 9.35833 20.921 10.4898 20.921C11.6213 20.921 12.5417 20.0005 12.5417 18.869C12.5417 18.5545 12.4704 18.2563 12.3433 17.9896H16.0451C15.9182 18.2563 15.8469 18.5543 15.8469 18.8687C15.8469 20.0002 16.7674 20.9207 17.8988 20.9207C19.0302 20.9207 19.9508 20.0002 19.9508 18.8687C19.9508 18.542 19.8737 18.2331 19.7373 17.9587C19.9693 17.8805 20.1365 17.6617 20.1365 17.4034C20.1365 17.0796 19.8741 16.8172 19.5503 16.8172H7.78141ZM11.3692 18.8691C11.3692 19.354 10.9747 19.7485 10.4898 19.7485C10.0048 19.7485 9.61032 19.354 9.61032 18.8691C9.61032 18.3844 10.0044 17.9901 10.489 17.9897H10.4905C10.9751 17.9901 11.3692 18.3844 11.3692 18.8691ZM17.8989 19.7482C17.414 19.7482 17.0194 19.3537 17.0194 18.8688C17.0194 18.3886 17.4063 17.9974 17.8846 17.9897H17.9132C18.3916 17.9974 18.7784 18.3886 18.7784 18.8688C18.7784 19.3537 18.3838 19.7482 17.8989 19.7482ZM20.8247 7.93594C20.8281 7.94032 20.8276 7.94239 20.8269 7.94575L20.2274 10.5419H18.1973L18.543 7.92238L20.8157 7.93153C20.8192 7.93161 20.8212 7.9316 20.8247 7.93594ZM14.7806 14.3323V11.7144H16.8599L16.5144 14.3323H14.7806ZM11.8735 14.3323L11.5252 11.7144H13.6081V14.3323H11.8735ZM9.17469 14.3323H9.17285C9.02996 14.3323 8.90407 14.2359 8.86691 14.0986L8.2243 11.7144H10.3423L10.6906 14.3323H9.17469ZM11.3692 10.5419L11.0166 7.89209L13.6081 7.90253V10.5419L11.3692 10.5419ZM14.7806 10.5419V7.90725L17.361 7.91765L17.0146 10.5419H14.7806ZM9.83313 7.88728L10.1863 10.5419H7.90828L7.18993 7.87661L9.83313 7.88728ZM19.1207 14.3323H17.697L18.0425 11.7144H19.9566L19.4041 14.1069C19.3734 14.2397 19.2569 14.3323 19.1207 14.3323Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ShopsIcon;
